<button
  class="btn btn-primary no-arrow float-right"
  [disabled]="disabled"
  (click)="openWarningModal()"
>
  Print Report&nbsp;
  <span class="icon-file"></span>
</button>
